import { useState } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as TWEEN from "@tweenjs/tween.js";
import { Tween } from "@tweenjs/tween.js";



export default function TweenAnim(props: any) {
    const { camera } = useThree();
    const [completed, setCompleted] = useState<boolean>(false);
 
    const t = { x: 0, y: 0, z: 3.5 };
    const tweenAnim = new Tween(camera.position).to(t).duration(3000).easing(TWEEN.Easing.Cubic.Out);

        tweenAnim.start();
        tweenAnim.onComplete((v) => {
            setCompleted(true);
            console.log("Completed");
            //props.onCompleted();
        });
    
    useFrame(() => {
        if (!completed) {
            tweenAnim.update();
        }
    })

    return null;
}